import type { OgcCollectionLink } from '@angular-workspace/services';

const GEOPACKAGE_MEDIA_TYPE = 'application/geopackage+sqlite3';

/**
 * Finds the already-onboarded GeoPackage asset link (if any) in a collection's
 * `links` array, e.g. `{ rel: 'enclosure', type: 'application/geopackage+sqlite3' }`.
 */
export function findExistingGeoPackageLink(
  links: OgcCollectionLink[] | null | undefined,
): OgcCollectionLink | null {
  if (!links?.length) {
    return null;
  }
  return (
    links.find((link) => link.type === GEOPACKAGE_MEDIA_TYPE) ??
    links.find(
      (link) => link.rel === 'enclosure' && link.href?.trim(),
    ) ??
    null
  );
}
